<template>
  <admin-wrapper title-translation-path="admin.EVENTS_LOG" :has-buttons="false" :inputs="inputs">
    <template #table.input>
      <events-log-tab />
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import EventsLogTab from '@/components/EventsLogTab';

export default {
  name: 'EventsLogSettings',
  components: {
    AdminWrapper,
    EventsLogTab,
  },
  computed: {
    inputs() {
      return [
        {
          name: 'table',
          isNamedSlot: false,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped></style>
